'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _shopifySectionsManager = require('shopify-sections-manager');

var _shopifySectionsManager2 = _interopRequireDefault(_shopifySectionsManager);

var _StaticCollection = require('../sections/StaticCollection');

var _StaticCollection2 = _interopRequireDefault(_StaticCollection);

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

require('../../styles/templates/collection.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sections = window.shopifySections || new _shopifySectionsManager2.default();

var CollectionPage = function CollectionPage() {
  (0, _classCallCheck3.default)(this, CollectionPage);

  this.el = document.body;

  sections.register('static-collection', function (section) {
    return new _StaticCollection2.default(section);
  });

  _rimgShopify2.default.init();
};

exports.default = CollectionPage;


new CollectionPage();